/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUsers = /* GraphQL */ `
  query GetUsers($getUsersInput: GetUsersInput!) {
    getUsers(getUsersInput: $getUsersInput) {
      data {
        PK
        SK
        id
        userType
        email
        data
        status
        prefix
        firstName
        lastName
        school
        schoolCode
        avatar
        detail
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($getUserInput: GetUserInput!) {
    getUser(getUserInput: $getUserInput) {
      data {
        PK
        SK
        id
        userType
        email
        data
        status
        prefix
        firstName
        lastName
        school
        schoolCode
        avatar
        detail
        createdAt
        updatedAt
      }
    }
  }
`;
export const findUser = /* GraphQL */ `
  query FindUser($findUserInput: FindUserInput!) {
    findUser(findUserInput: $findUserInput) {
      data {
        PK
        SK
        id
        userType
        email
        data
        status
        prefix
        firstName
        lastName
        school
        schoolCode
        avatar
        detail
        createdAt
        updatedAt
      }
    }
  }
`;
export const getTeachers = /* GraphQL */ `
  query GetTeachers($getTeachersInput: GetTeachersInput!) {
    getTeachers(getTeachersInput: $getTeachersInput) {
      data {
        PK
        SK
        id
        code
        prefix
        firstName
        lastName
        email
        classes
        status
        school
        schoolCode
        avatar
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSchools = /* GraphQL */ `
  query GetSchools($getSchoolsInput: GetSchoolsInput!) {
    getSchools(getSchoolsInput: $getSchoolsInput) {
      data {
        PK
        SK
        id
        schoolCode
        name
        email
        address
        city
        state
        zip
        avatar
        data
        createdAt
        updatedAt
        status
      }
      nextToken
    }
  }
`;
export const getSchoolList = /* GraphQL */ `
  query GetSchoolList($getSchoolListInput: GetSchoolListInput!) {
    getSchoolList(getSchoolListInput: $getSchoolListInput) {
      data {
        PK
        SK
        id
        name
        address
        city
        state
        zip
        createdAt
        updatedAt
        status
      }
      nextToken
    }
  }
`;
export const getStudents = /* GraphQL */ `
  query GetStudents($getStudentsInput: GetStudentsInput!) {
    getStudents(getStudentsInput: $getStudentsInput) {
      data {
        PK
        SK
        id
        code
        firstName
        lastName
        identityType
        identityImage
        identityCode
        classes
        school
        schoolCode
        level
        currentPath
        pathId
        nextPath
        lastResult
        paths
        avatar
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getClassrooms = /* GraphQL */ `
  query GetClassrooms($getClassroomsInput: GetClassroomsInput!) {
    getClassrooms(getClassroomsInput: $getClassroomsInput) {
      data {
        PK
        SK
        id
        name
        level
        clsCode
        code
        students
        school
        schoolCode
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContents = /* GraphQL */ `
  query GetContents($getContentsInput: GetContentsInput!) {
    getContents(getContentsInput: $getContentsInput) {
      data {
        PK
        SK
        id
        method
        category
        name
        title
        contentType
        description
        level
        owner
        createdAt
        updatedAt
        partsDescription
        structure {
          partsCount
          partElements
          defaultPresentation
        }
        parts {
          id
          name
        }
        benchmarkId
        benchmarkVersion
        contentVersion
        status
      }
      nextToken
    }
  }
`;
export const getContent = /* GraphQL */ `
  query GetContent($getContentInput: GetContentInput!) {
    getContent(getContentInput: $getContentInput) {
      data {
        PK
        SK
        id
        method
        category
        name
        title
        contentType
        description
        level
        owner
        createdAt
        updatedAt
        partsDescription
        structure {
          partsCount
          partElements
          defaultPresentation
        }
        parts {
          id
          name
        }
        benchmarkId
        benchmarkVersion
        contentVersion
        status
      }
    }
  }
`;
export const getParts = /* GraphQL */ `
  query GetParts($getPartsInput: GetPartsInput!) {
    getParts(getPartsInput: $getPartsInput) {
      data {
        PK
        SK
        id
        name
        level
        partNumber
        parentId
        parentName
        description
        method
        details {
          index
          elements
          elementType
          elementLength
          wordCount
        }
        data
        createdAt
        updatedAt
        status
      }
      nextToken
    }
  }
`;
export const getEPaths = /* GraphQL */ `
  query GetEPaths($getEPathsInput: GetEPathsInput!) {
    getEPaths(getEPathsInput: $getEPathsInput) {
      data {
        PK
        SK
        id
        name
        title
        pathType
        level
        description
        config
        elementCount
        elements {
          id
          name
        }
        contentVersion
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAssessments = /* GraphQL */ `
  query GetAssessments($getAssessmentsInput: GetAssessmentsInput!) {
    getAssessments(getAssessmentsInput: $getAssessmentsInput) {
      data {
        PK
        SK
        id
        pathName
        pathId
        pathTitle
        studentId
        teacherCode
        schoolCode
        asmtStatus
        elementCount
        elements {
          id
          name
          status
          scoreId
          contentId
          timelimit
          totalDuration
          updatedAt
        }
        createdAt
        updatedAt
        status
      }
      nextToken
    }
  }
`;
export const getAssessment = /* GraphQL */ `
  query GetAssessment($getAssessmentInput: GetAssessmentInput!) {
    getAssessment(getAssessmentInput: $getAssessmentInput) {
      data {
        PK
        SK
        id
        pathName
        pathId
        pathTitle
        studentId
        teacherCode
        schoolCode
        asmtStatus
        elementCount
        elements {
          id
          name
          status
          scoreId
          contentId
          timelimit
          totalDuration
          updatedAt
        }
        createdAt
        updatedAt
        status
      }
    }
  }
`;
export const getScore = /* GraphQL */ `
  query GetScore($getScoreInput: GetScoreInput!) {
    getScore(getScoreInput: $getScoreInput) {
      data {
        id
        scoreType
        assessmentId
        componentId
        studentId
        totalItems
        correct
        errors
        data
        duration
        timeLimitOffset
        contentType
        benchmarkId
        benchmarkVersion
        status
        updatedAt
      }
    }
  }
`;
export const getBenchmark = /* GraphQL */ `
  query GetBenchmark($getBenchmarkInput: GetBenchmarkInput!) {
    getBenchmark(getBenchmarkInput: $getBenchmarkInput) {
      data {
        id
        description
        method
        duration
        contentType
        level
        timeframes {
          timing
          values {
            name
            min
            max
          }
        }
        version
      }
    }
  }
`;
export const getBenchmarks = /* GraphQL */ `
  query GetBenchmarks($getBenchmarksInput: GetBenchmarksInput!) {
    getBenchmarks(getBenchmarksInput: $getBenchmarksInput) {
      data {
        id
        description
        method
        duration
        contentType
        level
        timeframes {
          timing
          values {
            name
            min
            max
          }
        }
        version
      }
    }
  }
`;
export const getAssessmentById = /* GraphQL */ `
  query GetAssessmentById($getAssessmentByIdInput: GetAssessmentByIdInput!) {
    getAssessmentById(getAssessmentByIdInput: $getAssessmentByIdInput) {
      data {
        assessments {
          PK
          SK
          id
          pathName
          pathId
          pathTitle
          studentId
          teacherCode
          schoolCode
          asmtStatus
          elementCount
          elements {
            id
            name
            status
            scoreId
            contentId
            timelimit
            totalDuration
            updatedAt
          }
          createdAt
          updatedAt
          status
        }
        contents {
          PK
          SK
          id
          name
          contentId
          contentIndex
          assessmentId
          studentId
          teacherCode
          schoolCode
          asmtStatus
          timelimit
          totalDuration
          partsCount
          parts {
            id
            name
            status
            scoreId
            partId
            duration
            timeLimitOffset
          }
          contentType
          createdAt
          updatedAt
          status
        }
        parts {
          PK
          SK
          id
          assessmentId
          assessmentContentId
          audioPath
          bucket
          enabled
          testErrors
          level
          metricsJson {
            diffs_processed {
              difftype
              diffstring
            }
            insertions
            substitutions
            deletions
            processed_transcript
            editops {
              editType
              editsrc
              editdst
            }
            phonetic_error_word_idxs
            text_error_idxs
            nr_words
            nr_word_errors
            diffs {
              difftype
              diffstring
            }
            char2word
            wer
          }
          nrWords
          nrWordsErrors
          duration
          timeLimitOffset
          phoneticGndTruth
          phonetics
          prediction
          contentText
          scriptText
          phonemeText
          createdAt
          updatedAt
          status
        }
        scores {
          id
          scoreType
          assessmentId
          componentId
          studentId
          totalItems
          correct
          errors
          data
          duration
          timeLimitOffset
          contentType
          benchmarkId
          benchmarkVersion
          status
          updatedAt
        }
      }
      status
    }
  }
`;
export const getStudentAssessments = /* GraphQL */ `
  query GetStudentAssessments(
    $getStudentAssessmentsInput: GetStudentAssessmentsInput!
  ) {
    getStudentAssessments(
      getStudentAssessmentsInput: $getStudentAssessmentsInput
    ) {
      data {
        PK
        SK
        id
        pathName
        pathId
        pathTitle
        studentId
        teacherCode
        schoolCode
        asmtStatus
        elementCount
        elements {
          id
          name
          status
          scoreId
          contentId
          timelimit
          totalDuration
          updatedAt
        }
        createdAt
        updatedAt
        status
      }
      nextToken
    }
  }
`;
export const getAssessmentContentByIxId = /* GraphQL */ `
  query GetAssessmentContentByIxId(
    $getAssessmentContentByIxIdInput: GetAssessmentContentByIxIdInput!
  ) {
    getAssessmentContentByIxId(
      getAssessmentContentByIxIdInput: $getAssessmentContentByIxIdInput
    ) {
      data {
        PK
        SK
        id
        name
        contentId
        contentIndex
        assessmentId
        studentId
        teacherCode
        schoolCode
        asmtStatus
        timelimit
        totalDuration
        partsCount
        parts {
          id
          name
          status
          scoreId
          partId
          duration
          timeLimitOffset
        }
        contentType
        createdAt
        updatedAt
        status
      }
    }
  }
`;
export const getAssessmentPartsByIxId = /* GraphQL */ `
  query GetAssessmentPartsByIxId(
    $getAssessmentPartsByIxIdInput: GetAssessmentPartsByIxIdInput!
  ) {
    getAssessmentPartsByIxId(
      getAssessmentPartsByIxIdInput: $getAssessmentPartsByIxIdInput
    ) {
      data {
        PK
        SK
        id
        assessmentId
        assessmentContentId
        audioPath
        bucket
        enabled
        testErrors
        level
        metricsJson {
          diffs_processed {
            difftype
            diffstring
          }
          insertions
          substitutions
          deletions
          processed_transcript
          editops {
            editType
            editsrc
            editdst
          }
          phonetic_error_word_idxs
          text_error_idxs
          nr_words
          nr_word_errors
          diffs {
            difftype
            diffstring
          }
          char2word
          wer
        }
        nrWords
        nrWordsErrors
        duration
        timeLimitOffset
        phoneticGndTruth
        phonetics
        prediction
        contentText
        scriptText
        phonemeText
        createdAt
        updatedAt
        status
      }
    }
  }
`;
